import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=279d04da&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279d04da')) {
      api.createRecord('279d04da', component.options)
    } else {
      api.reload('279d04da', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=279d04da&", function () {
      api.rerender('279d04da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9Jp6aPrZG4M/JS/comp/ErrorMessage.vue"
export default component.exports